<script setup lang="ts">
/**
 * @description UI-kit typography component — text link
 * @category UI / Typography
 * @figma https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/CS-UI-kit?node-id=216-126902
 */
// types
import type { AppTextLinkProps } from '../types/interfaces'
// hooks
import { useAppText } from '../composables/use-app-text.hook'

defineOptions({ name: 'AppTextLink' })

const props = withDefaults(defineProps<AppTextLinkProps>(), {
  name: 'body2',
  align: 'inherit',
  textDecoration: 'none',
  block: false,
  truncate: false,
})

const emit = defineEmits<{
  click: []
}>()

const {
  resolvedTag,
  classList,
  linkAttrs,
  handleClick,
} = useAppText({
  props,
  onClick: () => emit('click'),
})
</script>

<template>
  <component
    :is="resolvedTag"
    :class="classList"
    v-bind="linkAttrs"
    @click="handleClick"
  >
    <slot />
  </component>
</template>

<style scoped lang="scss" src="../styles/_app-text.scss" />
